import React from 'react';

import { routes } from '@aline/routes';
import { Helmet } from 'react-helmet';
import { Route, Routes, useLocation } from 'react-router-dom';
import { ContentWrapper, ReportPage, ReportsList } from 'src/components';
import { Apollo } from 'src/gql/generated';
import { createRelativeRouter } from 'src/helpers/router-helpers';

const { toRelativePath: toRelativeReportsPath } = createRelativeRouter(routes.ReportIndex, {
  nestedRoutes: true,
});

export function Reports(): JSX.Element {
  const location = useLocation();
  // Subscribe to AI reminder automation updates for all Reports in the Org.
  Apollo.useOnAiReminderAutomationUpdatedSubscription();

  return (
    <>
      <Helmet>
        <title>Reports</title>
      </Helmet>
      <Routes location={location.pathname}>
        <Route
          element={
            <ContentWrapper>
              <ReportsList />
            </ContentWrapper>
          }
          path={toRelativeReportsPath(routes.ReportIndex)}
        />
        <Route element={<ReportPage />} path={toRelativeReportsPath(routes.ReportDetail)} />
      </Routes>
    </>
  );
}
